import CookieConsent from "@/components/CookieConsent";
import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Dashboard from "@/pages/Dashboard";
import NewAnalysis from "@/pages/NewAnalysis";
import SourceSelection from "@/pages/SourceSelection";
import Report from "@/pages/Report";
import BatchView from "@/pages/BatchView";
import CaseHistory from "@/pages/CaseHistory";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/analyze" element={<NewAnalysis />} />
              <Route path="/source-select/:caseId" element={<SourceSelection />} />
              <Route path="/report/:caseId" element={<Report />} />
              <Route path="/batches" element={<BatchView />} />
              <Route path="/batch/:batchId" element={<BatchView />} />
              <Route path="/history" element={<CaseHistory />} />
              <Route path="/account" element={<Account />} />
              <Route path="/admin" element={<Admin />} />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
           <CookieConsent />

      </div>
  );

}

export default App;
